import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Cutter',
        path: '/biblioteca/bibcutter',
        name: 'bibcutter',
        component: () => import('@/views/biblioteca/bibcutter/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CUTTERNOVO_MENU_1300801998],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Cutter',
        path: '/biblioteca/bibcutter/cadastro/:id?',
        parent: 'bibcutter',
        name: 'bibcutter_create',
        component: () => import('@/views/biblioteca/bibcutter/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CUTTERNOVO_MENU_1300801998],
        },
        goesToMenu: true,
    },
]
